document.addEventListener("DOMContentLoaded", function(){
  const scroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true
  });

// Recalcule la limite de scroll une fois toutes les images chargées,
  // sinon le bas du footer (réseaux + copyright) reste inaccessible.
  window.addEventListener('load', () => scroll.update());

  el_autohide = document.querySelector('.autohide');
  navbar_height = document.querySelector('.navbar').offsetHeight;
  main = document.querySelector('main');
  main.style.paddingTop = navbar_height + 'px';
  document.querySelector('.headline').classList.add('animate');
  document.querySelector('.hand-background').classList.add('animate');
  document.querySelector('.star-background').classList.add('animate');
  document.querySelector('.r2b-background').classList.add('animate');

  if(el_autohide){
    var last_scroll_top = 0;
    scroll.on('scroll', function(obj) {
      let scroll_top = obj.scroll.y;
      if(scroll_top < last_scroll_top) {
        el_autohide.classList.remove('scrolled-down');
        el_autohide.classList.add('scrolled-up');
      }
      else {
          el_autohide.classList.remove('scrolled-up');
          el_autohide.classList.add('scrolled-down');
        }
      last_scroll_top = scroll_top;
    }); 
  }

  window.scrollToSubscribeSection = function() {
    element = document.querySelector('#formules');
    scroll.scrollTo('#formules');
  }
}); 